import React, { useState } from "react";
import "../../basic/login/login.css";
import { Form, Input, Button, Select } from "antd";
import { useNavigate } from "react-router-dom";
import apis from "../../../services/Apis";
import { Post } from "../../../services/axiosCall";
import Alert from "../../common/alert";
import { givenLevels } from "../../common/constants";
import { useDispatch, useSelector } from "react-redux";
// import { SearchTutor } from "../../../actions/traineeAction";
import { Navigate } from "react-router-dom";

const { Option } = Select;

const TraineeRegisterForm = () => {
  const [form] = Form.useForm();
  const [inform, setInform] = useState(true);
  const [link, setLink] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    navigate("/register");
  };

  const handleLoginClick = () => {
    navigate("/");
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      // console.log(values);
      

      const res = await Post({
        url: apis.REGISTER_TRAINEE_FOR_TEST,
        data: {
          name: values.name,
          emailid: values.email,
          password: values.password,
          postelCode: values.postalCode,
          level: values.level,
          contact: values.prefix + values.contact,
        },
      });

      if (res.data.success) {
        setInform(false);
        setLink(res.data.testLink);
        Alert("success","Success!",res.data.message)
        form.resetFields();
      } else {
        Alert("info", "Error!", res.data.message);
      }
    } catch (error) {
      form.resetFields();
      const message = error?.response?.data?.message || error.message;
      Alert("error", "Error!", message);
    }
  };

  if (!inform && link) return <Navigate to={link} />;

  return (
    <div className="home-page-container">
      <div className="parallax">
        <div className="login-container">
          <div className="login-student-inner">
            <div className="space-btw">
              <Button className="register-btn" ghost onClick={handleLoginClick}>
                Sign In
              </Button>
              <Button className="login-btn" ghost onClick={handleClick}>
                Register
              </Button>
            </div>
            <div className="login-log">
              <img
                src="/assets/leagueonlinelogo2.png"
                alt="logo"
                height={"70px"}
              />
            </div>
            <Form
              form={form}
              onFinish={handleSubmit}
              className="login-form"
              layout="vertical"
              initialValues={{ prefix: "+65" }}
            >
              <Form.Item
                label={<span style={{ color: "white" }}>Email</span>}
                name="email"
                rules={[
                  { type: "email", message: "This is not valid E-mail!" },
                  { required: true, message: "Please enter your E-mail!" },
                ]}
                hasFeedback
              >
                <Input placeholder="Email" />
              </Form.Item>

              <div className="space-btw-registor" style={{ gap: "12px" }}>
                <Form.Item
                  label={
                    <span style={{ color: "white" }}>
                      Child’s Level of Study
                    </span>
                  }
                  name="level"
                  rules={[{ required: true, message: "Please select Level" }]}
                  hasFeedback
                  style={{ width: "100%" }}
                >
                  <Select
                    showSearch
                    placeholder="Select Level"
                    optionFilterProp="children"
                    style={{ height: "57px" }}
                  >
                    {givenLevels.map((d) => (
                      <Option key={d.value} value={d.value}>
                        {d.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label={
                    <span style={{ color: "white" }}>Child’s First Name</span>
                  }
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your Child’s First Name",
                    },
                  ]}
                  hasFeedback
                  style={{ width: "100%" }}
                >
                  <Input placeholder="Child’s First Name" />
                </Form.Item>
              </div>

              <Form.Item
                label={<span style={{ color: "white" }}>Postal Code</span>}
                name="postalCode"
                rules={[
                  { required: true, message: "Please enter your postal code" },
                  {
                    pattern: /^[0-9]{1,6}$/,
                    message: "Enter a valid postal code (up to 6 digits)",
                  },
                ]}
                hasFeedback
              >
                <Input type="number" placeholder="Postal Code" />
              </Form.Item>
              <Form.Item
                label={<span style={{ color: "white" }}>Phone Number</span>}
                name="contact"
                rules={[
                  {
                    required: true,
                    message: "Please input your phone number!",
                  },
                  { len: 8, message: "Contact number must be 8 digits long" },
                  {
                    pattern: /^\d{8}$/,
                    message: "Contact number must be exactly 8 digits",
                  },
                ]}
                hasFeedback
              >
                <Input
                style={{backgroundColor:'white', borderRadius:'5px'}}
                  addonBefore={
                    <Form.Item name="prefix" noStyle style={{backgroundColor:'white'}}>
                      <Select
                        style={{ width: 70,}}
                        defaultValue="+65"
                      >
                        <Select.Option value="+65">+65</Select.Option>
                      </Select>
                    </Form.Item>
                  }
                  type="tel"
                  maxLength={8}
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ color: "white" }}>Password</span>}
                name="password"
                rules={[{ required: true, message: "Please enter password" }]}
                hasFeedback
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item
                label={
                  <span style={{ color: "white" }}>Re-enter your Password</span>
                }
                name="retypePassword"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  { required: true, message: "Please re-enter your password" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Re-enter your Password" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Register
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraineeRegisterForm;
